import { api } from '../core';
import { MEDICAL_RECORDS_TAG } from '../constants';

export interface DocumentGetUploadUnassignedResponse {
  uploadPath: string;
  uploadToken: string;
}

type DocumentGetUploadUnassignedProps = {
  documentId: string | null;
  unassignedDocumentId: string | null;
};

const documentGetUploadUnassignedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentGetUploadUnassigned: builder.query<
      DocumentGetUploadUnassignedResponse,
      DocumentGetUploadUnassignedProps
    >({
      query: ({ documentId, unassignedDocumentId }: DocumentGetUploadUnassignedProps) => ({
        url: `document/get-upload/unassigned`,
        method: 'POST',
        body: {
          documentId: documentId,
          unassignedDocumentId: unassignedDocumentId
        }
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([MEDICAL_RECORDS_TAG]));
        } catch (error) {
          console.error('Error in postDocumentGetUploadUnassigned in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentGetUploadUnassignedQuery } = documentGetUploadUnassignedApi;
